<template>
  <div class="user_container" v-show="isShow">
    <div style="display:inline-block;padding:10px 10px 10px 20px;cursor: pointer;" @click="bindBack">
      <div style="width:12px;height:12px;border-left:1px solid #000;border-bottom:1px solid #000;margin-left:10%;transform:rotate(45deg)"></div>
    </div>
    <div class="nav_title">{{nav_title}}</div>
  </div>
</template>

<script>
import config from '../../../config';
import util from '../../../utils/utils';
export default {
  props:{
    'title':{
      type:String,
      default:""
    },
  },
  components:{
    
  },
  data(){
    return {
      isShow:true,
      nav_title:this.title
    }
  },
  watch:{
    title:{
      handler(newVal,oldVal){
        this.nav_title=newVal;
      },
      immediate:false //
    },
  },
  mounted(){
    // 如果是微信就不显示
    this.isShow=!util.isWechat()
  },
  beforeDestroy(){
    
  },
  methods:{ 
    bindBack(){
      window.history.back(-1); 
    }
  }
}
</script>

<style scoped>
  div,div{
    box-sizing: border-box;
  }
  .user_container{
    width: 100%;
    height: 6vh;
    background: #f8f8f8;
    /* box-shadow: 1px 0 5px rgba(0,0,0,0.4); */
    box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    position: relative;
  }
  .nav_title{
    width: 100%;
    height: 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    display:flex;
    justify-content: center;
    align-items: center;
    font-size: 0.35rem;
    font-weight: bold;
  }
</style>